__turbopack_context__.v({
  "answer_text": "styles-module-scss-module__If5Ppq__answer_text",
  "faq_block": "styles-module-scss-module__If5Ppq__faq_block",
  "faq_item": "styles-module-scss-module__If5Ppq__faq_item",
  "faq_list": "styles-module-scss-module__If5Ppq__faq_list",
  "heading": "styles-module-scss-module__If5Ppq__heading",
  "question_text": "styles-module-scss-module__If5Ppq__question_text",
});
